var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 315,
    viewBox: "0 0 300 315",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M299.464 225.708C287.221 251.191 268.344 272.909 244.814 288.582C221.285 304.255 193.97 313.306 165.737 314.784C137.504 316.263 109.394 310.115 84.356 296.986C59.3181 283.856 38.2757 264.229 23.4372 240.165C8.59877 216.1 0.511261 188.485 0.0234472 160.218C-0.464367 131.95 6.6655 104.073 20.6648 79.5104C34.6641 54.9481 55.0167 34.6069 79.5868 20.6213C104.157 6.63569 132.038 -0.478606 160.306 0.0249889L159.86 25.0176C136.079 24.5939 112.623 30.5791 91.9522 42.3451C71.2817 54.111 54.1592 71.224 42.3817 91.888C30.6042 112.552 24.6059 136.005 25.0163 159.786C25.4267 183.567 32.2306 206.8 44.7141 227.045C57.1976 247.29 74.9003 263.802 95.9646 274.848C117.029 285.894 140.678 291.066 164.43 289.822C188.182 288.578 211.162 280.964 230.957 267.778C250.752 254.593 266.633 236.322 276.933 214.883L299.464 225.708Z",
    fill: "#E9F6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCircle);
export default __webpack_public_path__ + "static/media/blue-circle.39c5e2a1dc68160c3942a79cd329f1f0.svg";
export { ForwardRef as ReactComponent };